module.exports = {
  ORG: {
    ADMIN: '6c1fba5d-633a-4d54-9077-a50a5bd4e7e0',
    ADMIN_LITE: '35f029df-33ca-4c53-a02c-bbd6c92a5f35',
    READ_ONLY: 'fc6310f9-9cd3-446b-8331-ff94c7279f95',
  },
  EVENT: {
    ADMIN: '7c1fba5d-633a-4d54-9077-a50a5bd4e7e0',
    ADMIN_LITE: '62fbf8e7-4aa3-40a0-aaf3-18727cde55d2',
    REPORTING_ONLY_ADMIN: '9be06234-6c3a-481f-8a81-3a41b07ec9b7',
    COMMUNICATION_MANAGER: '18ac3a77-9b88-4ff2-a786-512a890a7a69',
    SESSION_MANAGER: 'e17ef7d1-0ef6-4f11-ba68-8c1f8aee80ec',
    CONTENT_MANAGER: 'a61b7c53-ec82-4f9e-93c7-8e30f887d31e',
    EVALUATOR: 'ac1fba5d-633a-4d54-9077-a50a5bd4e7e0',
    EVALUATOR_SESSION_MANAGER: '34e1a442-bf4a-4c1f-aa88-d34a87fb98a7',
    PORTAL_USER: '2792ef9f-b0c5-41f3-b1c6-81a9de7a945e',
    SPONSOR_MANAGER: 'f5776abc-fded-423c-8583-9733004849d2',
    EXHIBITOR_MANAGER: '011a2457-7adc-4db5-a96a-eec64da53f0f',
  },
};
